import { Error, Refresh } from '@mui/icons-material';
import { AppBar, Button, Stack, Toolbar, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import logo from '../../assets/diamonddigital-logo.svg';

export default function ErrorPage() {
  const { t } = useTranslation('global');
  return (
    <>
      <AppBar
        sx={{ backgroundColor: theme => theme.palette.grey[900], p: 2 }}
        position="static"
      >
        <Toolbar sx={{ justifyContent: 'center' }}>
          <img src={logo} alt="Logo" style={{ maxWidth: '203px' }} />
        </Toolbar>
      </AppBar>
      <Stack
        justifyContent="center"
        height="calc(100vh - 96px)"
        alignItems="center"
      >
        <Error sx={{ fontSize: '6rem' }} color="error" />
        <Typography variant="h6" my={2}>
          {t('error.title')}
        </Typography>
        <Typography variant="body1" textAlign="center" mb={3}>
          {t('error.message1')} <br /> {t('error.message2')}
        </Typography>
        <Button
          startIcon={<Refresh />}
          variant="contained"
          data-testid="refresh"
          onClick={() => window.location.reload()}
        >
          {t('error.button')}
        </Button>
      </Stack>
    </>
  );
}
